import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["drawer"];
  
  open() {
    this.drawerTarget.classList.toggle("hidden");

    var main = document.getElementById('main');
    main.classList.toggle('scroll-disable');
  }

  close() {
    this.drawerTarget.classList.add("hidden");

    var main = document.getElementById('main');
    main.classList.toggle('scroll-disable');
  }
}
